import React from 'react';

import EventIcon from './event-icon';
import style from './index.less';

const EventMsgAppOpen = props => {
  return (
    <div className={style['event-box']}>
      <ul className={style.header}>
        <li>
          <EventIcon action='mpush_clue' />
        </li>
        <li>用户已通过交易卡唤端成功</li>
      </ul>
    </div>
  );
};

export default EventMsgAppOpen;
